export const GET_DOWNLOADS = {
  REQUEST: "GET_DOWNLOADS",
  PENDING: "GET_DOWNLOADS_PENDING",
  FULFILLED: "GET_DOWNLOADS_FULFILLED",
  FAILED: "GET_DOWNLOADS_FAILED"
}

export const SET_SEARCH = 'SET_DOWNLOADS_SEARCH'